

<form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
  <div class="mb-3">
    <label for="firstName" i18n="@@FirstnameLabel">Vorname*</label>
    <input type="text" id="firstName" formControlName="firstName" class="form-control" i18n-placeholder="@@FirstnamePlaceholder" placeholder="Vorname" />

    <div class="error">
      <em *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'required')" i18n="@@FirstnameRequiredError">Vorname wird benötigt</em>
      <em *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'pattern')" i18n="@@IncorrectInputError">Falsche Eingabe</em>
    </div>
  </div>

  <div class="mb-3">
    <label for="lastname" i18n="@@LastnameLabel">Nachname*</label>
    <input type="text" id="lastName" formControlName="lastName" class="form-control" i18n-placeholder="@@LastnamePlaceholder" placeholder="Nachname*" />

    <div class="error">
      <em *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'required')" i18n="@@LastnameRequiredError">Nachname wird benötigt</em>
      <em *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'pattern')" i18n="@@IncorrectInputError">Falsche Eingabe</em>
    </div>
  </div>

  <div class="mb-3">
    <label for="email" i18n="@@E-MailLabel">E-Mail</label>
    <input type="text" id="email" formControlName="email" class="form-control" i18n-placeholder="@@EmailPlaceholder" placeholder="E-Mail" (blur)="checkEmail()" />

    <div class="error">
      <em *ngIf="formService.validateControl('email') && formService.hasError('email', 'email')" i18n="@@E-MailIncorrectInputError">E-Mail ist nicht gültig</em>
      <em *ngIf="formService.validateControl('email') && formService.hasError('email', 'required')" i18n="@@E-MailRequiredError">E-Mail wird benötigt</em>
      <em *ngIf="this.emailExists" i18n="@@E-MailRequiredError">E-Mail existiert bereits </em>
    </div>
  </div>





  <div class="mb-3" id="tags-input">
    <label for="tags" i18n="@@UserRfidTagsLabel">RFID-Karten</label>
    <ng-select #tagsSelect id="tags"
               [addTag]="addTagRef"
               [appendTo]="'body'"
               [items]="availableRfidCards"
               bindLabel="idTag"
               multiple="true"
               [hideSelected]="true"
               [closeOnSelect]="false"
               [clearSearchOnAdd]="true"
               formControlName="selectedTags"
               placeholder="RFID-Tags"
               i18n-placeholder="@@RfidTags"
               i18n-notFoundText="@@NoEntriesAvailable"
               notFoundText="Keine Einträge vorhanden"
               (keyup)="ngSelect_KeyupEvent($event)"
               (keypress)="ngSelect_KeypressEvent($event)"
               (paste)="ngSelect_PastEvent($event)"
               (input)="ngSelect_InputEvent($event)"
               (blur)="onBlur()">


      <ng-template ng-tag-tmp let-search="searchTerm">
        <ng-container *ngIf="condition">
          <b>Erstelle neu</b>: {{ search }} <span class="error" *ngIf="error">{{ errorMessage }}</span>
        </ng-container>
      </ng-template>
    </ng-select>
  </div>












  <span class="text-muted" i18n="@@RequiredFieldsLabel">*Pflichtfelder</span>
</form>

